<template>
  <form @submit.prevent="handleSubmit" class="flex gap-2">
    <Textarea
      ref="textareaRef"
      v-model="message"
      :disabled="disabled"
      :auto-resize="true"
      rows="1"
      placeholder="Ask Righty anything..."
      class="flex-1"
      :pt="{
        root: {
          class: 'max-h-32 min-h-[2.5rem] resize-none rounded-xl border-slate-300 text-sm focus:border-indigo-500 focus:ring-indigo-500 dark:border-slate-600 dark:bg-slate-800'
        }
      }"
      @keydown.enter.exact="handleEnter"
    />
    <Button
      type="submit"
      icon="pi pi-send"
      :disabled="disabled || !message.trim()"
      :loading="loading"
      rounded
      severity="primary"
      aria-label="Send message"
      :pt="{
        root: { class: 'h-10 w-10 !p-0' }
      }"
    />
  </form>
</template>

<script setup lang="ts">
const props = defineProps<{
  disabled?: boolean
  loading?: boolean
}>()

const emit = defineEmits<{
  send: [message: string]
}>()

const message = ref('')
const textareaRef = ref<InstanceType<typeof import('primevue/textarea')['default']> | null>(null)

function handleSubmit() {
  if (!message.value.trim() || props.disabled) return
  emit('send', message.value.trim())
  message.value = ''
}

function handleEnter(event: KeyboardEvent) {
  if (!event.shiftKey) {
    event.preventDefault()
    handleSubmit()
  }
}

function focus() {
  nextTick(() => {
    textareaRef.value?.$el?.focus()
  })
}

defineExpose({ focus })
</script>
